import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AnimationFrameService {
  private readonly core$: Subject<void> = new Subject<void>();

  public readonly on$: Observable<void>;

  constructor() {
    const { core$ } = this;

    this.on$ = core$.asObservable();

    const animationFrame = () => {
      core$.next();
      requestAnimationFrame(() => animationFrame());
    };

    animationFrame();
  }
}
